import { AgentKnowledgeSearchRequestSchema, AgentKnowledgeSearchResponseSchema, PublicSessionAnimationStatusResponseSchema, PublicSessionTextTurnRequestSchema, PublicSessionTextTurnResponseSchema, SessionTokenSchema, } from '@cloneai/shared-types/api';
export function createPublicSessionsResource(http) {
    return {
        searchKnowledge: (sessionId, body) => http.request({
            method: 'POST',
            path: `/v1/public/sessions/${encodeURIComponent(sessionId)}/knowledge/search`,
            body: AgentKnowledgeSearchRequestSchema.parse(body),
            responseSchema: AgentKnowledgeSearchResponseSchema,
            anonymous: true,
        }),
        sendTextTurn: (sessionId, body, proof) => http.request({
            method: 'POST',
            path: `/v1/public/sessions/${encodeURIComponent(sessionId)}/text-turn`,
            body: PublicSessionTextTurnRequestSchema.parse(body),
            responseSchema: PublicSessionTextTurnResponseSchema,
            anonymous: true,
            ...(proof ? { sessionToken: SessionTokenSchema.parse(proof.sessionToken) } : {}),
        }),
        getAnimation: (sessionId, animationId, proof) => http.request({
            method: 'GET',
            path: `/v1/public/sessions/${encodeURIComponent(sessionId)}/animations/${encodeURIComponent(animationId)}`,
            responseSchema: PublicSessionAnimationStatusResponseSchema,
            anonymous: true,
            sessionToken: SessionTokenSchema.parse(proof.sessionToken),
            ...(proof.signal ? { signal: proof.signal } : {}),
        }),
    };
}
//# sourceMappingURL=publicSessions.js.map